import React from "react";

const Wallet = () => {
  const handleConnectMetaMask = async () => {
    const { ethereum } = window;
    await ethereum.request({ method: "eth_requestAccounts" });
    // const provider_MetaMask = new providers.Web3Provider(window.ethereum);
  };
  return (
    <div className="row">
      <div className="col-lg-3 mb30" onClick={handleConnectMetaMask}>
        <span className="box-url left p-3">
          <span className="box-url-label">Popular</span>
          <img src="./img/wallet/1.png" alt="" className="mb20" />
          <h4>Metamask</h4>
          <p>Start exploring blockchain applications in seconds. Trusted by over 1 million users worldwide.</p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <img src="./img/wallet/4.png" alt="" className="mb20" />
          <h4>WalletConnect</h4>
          <p>Open source protocol for connecting decentralised applications to mobile wallets.</p>
        </span>
      </div>
    </div>
  );
};
export default Wallet;
